import { render, staticRenderFns } from "./SuccessSnackbar.vue?vue&type=template&id=3b0ef206"
import script from "./SuccessSnackbar.vue?vue&type=script&lang=js"
export * from "./SuccessSnackbar.vue?vue&type=script&lang=js"
import style0 from "./SuccessSnackbar.vue?vue&type=style&index=0&id=3b0ef206&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports